/**
 * 対象データタイプ（歳出/歳入/財源充当）の値一覧
 *
 * BEの分析APIエンドポイント区分に対応:
 * - expenditure: 歳出分析
 * - revenue: 歳入分析
 * - revenue-appropriation: 財源充当分析
 */
export const analysisTargetValues = ['expenditure', 'revenue', 'revenue-appropriation'] as const;

/** 対象データタイプ（値一覧から導出） */
export type AnalysisTarget = (typeof analysisTargetValues)[number];
